import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import TwoDBuildingMap from "./TwoDBuildingMap";
import { Checkbox } from "@rmwc/checkbox";
import TwoDFloorplanner from "./TwoDFloorplanner";
import TwodMapVideo from '../../../assets/images/two-d-Map/twodmap.mp4';
import { prepareTwoDMapData, downloadOnClick } from "../../../action/twoDMap.action";
import TwoDMapNotation from "./TwoDMapNotation";
import TwoDModalBody from "./TwoDModalBody";
import Dropdown from 'react-bootstrap/Dropdown';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import { jsPDF } from 'jspdf';
import { params, const_var, initialState } from "../../../redux/reducers/reducer";
const baseUrl = process.env.REACT_APP_BASE_URL;
let ImageData = [];
class TwoDMapModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenSVG: false,
      isOpenPDF: false,
      isAvailable: false,
      isOpenFloorplanner: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      previewIndex: 0,
      prevEnable: true,
      nextEnable: true,
      buttonVisible: true,
      previewStatus: "",
      checkCheckBoxStatus: false,
      showMore2DOpt: false
    };           
    this.hideFloorplanner = this.hideFloorplanner.bind(this);
  }


  autoClick = () => {
    // console.log("Ashish3",this.props.const_var.post_data.building);        
    //this.props.const_var.post_data?.building !== undefined && this.props.const_var.post_data.building && this.props.prepareTwoDMapData(this.props.const_var.post_data.building);
    prepareTwoDMapData();
    console.log(document.getElementById('autogenerated'));  
    if (document.getElementById('autogenerated') != undefined) {
      document.getElementById('autogenerated').style.contentVisibility = "visible";
      htmlToImage.toPng(document.getElementById('autogenerated'), { quality: 1 })
        .then(function (dataUrl) {
          document.getElementById('autogenerated').style.contentVisibility = "hidden";
          var pdfN = new jsPDF('p', 'px', 'a4', true, true);
          const_var.i_g_A_y2d = [];
          const_var.i_g_A_y2d.push({ "image": dataUrl, "image_name": "2D Layout" });
          // console.log(const_var.i_g_A_y2d);
          // var imgProps= pdfN.getImageProperties(dataUrl);
          // var pdfWidth = pdfN.internal.pageSize.getWidth();//500;//
          // var pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;//550;//
          // var width = pdfN.internal.pageSize.getWidth();
          // var height = pdfN.internal.pageSize.getHeight();
          // var widthRatio = width / imgProps.width;
          // var heightRatio = height / imgProps.height;
          // var ratio = widthRatio > heightRatio ? heightRatio : widthRatio;
          // pdfN.internal.scaleFactor = 10;        
          // pdfN.addImage(dataUrl, 'PNG', 0, 0,imgProps.width * ratio, imgProps.height * ratio,'null','SLOW',0 );
          // pdfN.save("2D-Layout.pdf");          
        })
    }
  };

  showFloorplanner = () => {
    document.querySelector('body').classList.add('active-twod-drawing-popup');

    if (const_var.checkIsEditData == true && const_var.i_g_A_y.length > 0) {
      for (let i = 0; i <= const_var.i_g_A_y.length - 1; i++) {
        if (const_var.i_g_A_y[i].image_name == "2D Layout1" && const_var.i_g_A_y[i].is_checked != undefined && const_var.i_g_A_y[i].is_checked == true) {
          const_var.i_g_A_y.splice(i, 1);
          const_var.i_g_A_y.splice(i, 1);
        }
        // if(const_var.i_g_A_y[i].image_name!=undefined && const_var.i_g_A_y[i].image_name=="2D Layout1" && const_var.i_g_A_y[i].is_checked!=undefined && const_var.i_g_A_y[i].is_checked==true)
        // {
        //     const_var.i_g_A_y.splice(i,1);
        // }
        const_var.twoDImageObj = [];
        const_var.checkIsEditData = false;
      }
    }
    this.setState({ isOpenFloorplanner: true,showMore2DOpt:false });
    // this.props.downloadOnClick(this.state.isOpenFloorplanner);
    // this.props.prepareTwoDMapData();
    const_var.ShowTwodLayoutDefault = true;

  };

  showPreview = () => {
    this.setState({ isOpenSVG: true,showMore2DOpt:false });
     document.querySelector('body').classList.add('active-twod-drawing-popup')

  };

  setPreviewStatus = (index) => {
    let status = (index + 1).toString() + " / " + ImageData.length.toString();
    this.setState({ previewStatus: status });
  }

  onShowPreview = () => {
    ImageData = window.twoDMapReqPng;
    if (const_var.i_g_A_y.length > 0 && ImageData == undefined) {
      ImageData = [];
      let filterResult = const_var.i_g_A_y.filter(data => data.is_checked != undefined);
      const_var.twoDImageObj = filterResult;
      for (let i = 0; i <= filterResult.length - 1; i++) {
        ImageData.push(filterResult[i].image);

      }
      //window.twoDMapReqPng = const_var.twoDImageObj;
      //const_var.ShowTwodLayoutDefault = true;
    }

    document.getElementById('previewImg').src = ImageData[0];
    this.setState({ previewIndex: 0, prevEnable: false });
    if (ImageData.length > 1) {
      this.setState({ nextEnable: true });
    } else {
      this.setState({ nextEnable: false });
    }
    if (ImageData.length > 1) {
      this.setState({ buttonVisible: true });
    } else {
      this.setState({ buttonVisible: false });
    }
    this.setPreviewStatus(0);
  };

  onPrevPreview = () => {
    if (this.state.previewIndex > 0) {
      document.getElementById('previewImg').src = ImageData[this.state.previewIndex - 1];
      if (this.state.previewIndex > 1) {
        this.setState({ prevEnable: true });
      } else {
        this.setState({ prevEnable: false });
      }
      this.setState({ nextEnable: true });
      this.setPreviewStatus(this.state.previewIndex - 1);
      this.setState({ previewIndex: this.state.previewIndex - 1 });
    }
  };
  addtoQuote = (e, value) => {
    if (const_var.twoDImageObj[this.state.previewIndex] == undefined) {
      const_var.twoDImageObj[this.state.previewIndex] = [];
    }
    const_var.twoDImageObj[this.state.previewIndex].image = ImageData[this.state.previewIndex];

    if (const_var.twoDImageObj[this.state.previewIndex].is_checked == undefined) {
      const_var.twoDImageObj[this.state.previewIndex].is_checked = false;
    }
    this.setState({ checkCheckBoxStatus: const_var.twoDImageObj[this.state.previewIndex].is_checked })
    const_var.twoDImageObj[this.state.previewIndex].is_checked = !const_var.twoDImageObj[this.state.previewIndex].is_checked;

  }
  onNextPreview = () => {
    if (this.state.previewIndex < ImageData.length - 1) {
      document.getElementById('previewImg').src = ImageData[this.state.previewIndex + 1];
      if (this.state.previewIndex < ImageData.length - 2) {
        this.setState({ nextEnable: true });
      } else {
        this.setState({ nextEnable: false });
      }
      this.setState({ prevEnable: true });
      this.setPreviewStatus(this.state.previewIndex + 1);
      this.setState({ previewIndex: this.state.previewIndex + 1 });
    }
  };

  hideFloorplanner = () => {
    this.setState({ isOpenFloorplanner: false });
    document.querySelector('body').classList.remove('active-twod-drawing-popup');

  };

  hidePreview = () => {
    this.setState({ isOpenSVG: false });
    document.querySelector('body').classList.remove('active-twod-drawing-popup');

  };

  requestFloorplannerImage = () => {
    const floorplanner = document.getElementById("floorplanner-" + "view");
    floorplanner.contentWindow.postMessage({
      "type": "image"
    });
  };

  downloadOnClick = () => {
    this.setState({ isOpenSVG: !this.state.isOpenSVG });
    this.props.downloadOnClick(!this.state.isOpenSVG);
    this.props.prepareTwoDMapData();

    /*console.log("Ashish2",this.props.const_var.post_data.building);        
    this.props.const_var.post_data?.building !== undefined && this.props.const_var.post_data.building && this.props.prepareTwoDMapData(this.props.const_var.post_data.building);
    this.setState({ isOpenSVG: !this.state.isOpenSVG });
    if(this.state.isOpenSVG == true)
    {
      htmlToImage.toPng(document.getElementById('svg'), { quality: 1 })
      .then(function (dataUrl) {
        const_var.i_g_A_y2d = [];
        const_var.i_g_A_y2d.push({"image":dataUrl,"image_name":"2D Layout"});
        //console.log(const_var.i_g_A_y2d);
      })
    }*/
  };
  downloadOnClickNew = (bw, bl) => {
    /*const pdf = new jsPDF('p', 'px', [900,700],true,true);
    htmlToImage.toBlob(document.getElementById('svg'), { quality: 0.98 ,pixelRatio:1 })
        .then(function (dataUrl) {
          const_var.i_g_A_y2d = [];
          var link = document.createElement('a');
          link.download = '2D-Layout.jpeg';
          //link.href = dataUrl;          
          //link.click();          
          //console.log(link,"Blob",dataUrl,const_var);
          const_var.i_g_A_y2d.push({"image":dataUrl,"image_name":"2D-Image"});                 
          const imgProps= pdf.getImageProperties(dataUrl);
          const pdfWidth = pdf.internal.pageSize.getWidth();//500;//
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;//550;//
          var width = pdf.internal.pageSize.getWidth();
          var height = pdf.internal.pageSize.getHeight();
          var widthRatio = width / imgProps.width;
          var heightRatio = height / imgProps.height;
          var ratio = widthRatio > heightRatio ? heightRatio : widthRatio;
          pdf.addImage(dataUrl, 'PNG', 0, 0 ,imgProps.width * ratio, imgProps.height * ratio);                              
          pdf.save("2D-Layout.pdf");
          //console.log(pdf);          
        });*/
    //const pdf = new jsPDF('p', 'px', 'a4',true,true);
    const pdf = new jsPDF('p', 'px', 'a4', true, true);
    //pdf.internal.pageSize.width = 450;
    //pdf.internal.pageSize.height = 650;
    // console.log(pdf);
    htmlToImage.toPng(document.getElementById('svg'), { quality: 1 })
      .then(function (dataUrl) {
        const_var.i_g_A_y2d = [];
        const_var.i_g_A_y2d.push({ "image": dataUrl, "image_name": "2D Layout" });
        var link = document.createElement('a');
        link.download = 'my-image-name.png';
        //link.href = dataUrl;
        //link.click();
        const imgProps = pdf.getImageProperties(dataUrl);
        const pdfWidth = pdf.internal.pageSize.getWidth();//500;//
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;//pdf.internal.pageSize.getHeight();//(imgProps.height * pdfWidth) / imgProps.width;//550;//
        var width = pdf.internal.pageSize.getWidth();
        var height = pdf.internal.pageSize.getHeight();
        // console.log(imgProps.width,imgProps.height,bw,bl,width,height);
        var widthRatio = (width) / imgProps.width;
        var heightRatio = height / imgProps.height;
        var ratio = widthRatio > heightRatio ? heightRatio : widthRatio;
        // console.log(widthRatio,heightRatio);
        var ratioW = 446.46 / bw;
        var ratioL = 631.45 / bl;
        pdf.internal.scaleFactor = 10;
        //pdf.addImage(dataUrl, 'PNG', 0, 0,imgProps.width * ratio, imgProps.height * ratio,'null','SLOW',0 );
        //pdf.addImage(dataUrl, 'PNG', 0, 0, imgProps.width * widthRatio, imgProps.height * heightRatio, 'null', 'SLOW', 0);

        pdf.addImage(dataUrl, 'JPEG', 0, 0, imgProps.width * ratio, imgProps.height * ratio, 'null', 'SLOW', 0);
        pdf.save("2D-Layout.pdf");
        //console.log(dataUrl,"const_var.i_g_A_y2d")
        //console.log(width,imgProps.width,height,imgProps.height,ratio);                        
    });    
  };   
  
  showMore2DOpt=(e)=>{
    e.stopPropagation();
    let resizePopuarSize = document.getElementById("pop-size")
    if(resizePopuarSize != undefined && resizePopuarSize != null){
      resizePopuarSize.classList.add("twoDExist")
    }
    let resizePopuarColor= document.getElementById("popular-color")
    if(resizePopuarColor != undefined && resizePopuarColor != null){
      resizePopuarColor.classList.add("popular-colors")
    }
    this.setState({
      showMore2DOpt: !this.state.showMore2DOpt
    })
  }

  handleClickOutside = (e) => {
    // if click outside of 2d section then need to close preview/new section
    const concernedElement = document.querySelector(".floorplannerIDDDD");
    const concernedElement2 = document.querySelector(".twod-map-option-right");
    if (concernedElement && !concernedElement.contains(e.target) || concernedElement2 && !concernedElement2.contains(e.target)) {
      this.setState({
        showMore2DOpt: false
      })
      let resizePopuarSize = document.getElementById("pop-size")
      if(resizePopuarSize != undefined && resizePopuarSize != null){
        resizePopuarSize.classList.remove("twoDExist")
      }
      let resizePopuarColor= document.getElementById("popular-color")
      if(resizePopuarColor != undefined && resizePopuarColor != null){
        resizePopuarColor.classList.remove("popular-colors")
      }
    }
  };

  // componentWillUnmount(){
  //   document.removeEventListener('mousedown', this.handleClickOutside);
  // }
  onResize = () => {
    this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    this.forceUpdate();
   }
  componentDidMount(){
     this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    window.addEventListener('resize', this.onResize);
    document.addEventListener('mousedown', this.handleClickOutside);
  }
   componentWillUnmount(){
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  render() {

    let Show2DModal = true;
    // console.log(const_var.i_g_A_y2d,"const_var.i_g_A_y2d")
    if (this.props.two_d_layuot != undefined && Object.keys(this.props.two_d_layuot).length > 0) {
      if (this.props.two_d_layuot.is_active != undefined && this.props.two_d_layuot.is_active == 1) {
        Show2DModal = true;
      }
    }
    if (const_var.twoDImageObj[this.state.previewIndex] != undefined && const_var.twoDImageObj[this.state.previewIndex].is_checked != undefined) {
      // console.log(const_var.twoDImageObj[this.state.previewIndex],const_var.twoDImageObj,'const_var.twoDImageObj[this.state.previewIndex]')
    }
    // console.log(const_var.post_data?.building !== undefined && const_var.post_data.building?const_var.post_data.building:'hhh')


    return (
      <Fragment>
        {/*-------- The commented is for genrating 2D manually ----------------------- */}
         {/* {window.innerWidth > 1000 ? const_var.ShowTwodLayoutDefault == false || window.twoDMapReqPng === undefined || (window.twoDMapReqPng && window.twoDMapReqPng.length == 0) ?
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-twodmap`}>Shows doors and windows sizes, spacing, building dimensions, and lean tos on a 2D floor plan.</Tooltip>}
          >
            <a onClick={this.showFloorplanner} data-tut="twoddrawing">
              <span className="text">2D Drawing</span>
              <span className="icon icon-draw-ico"></span>
            </a>
          </OverlayTrigger>
          :

          <div className="twod-option-with-option">
            <a onClick={(e)=>this.showMore2DOpt(e)} data-tut="twoddrawing">
              <span className="text" onClick={(e)=>this.showMore2DOpt(e)}>2D Drawing</span>
              <span className="icon icon-draw-ico"></span>
            </a>
            {this.state.showMore2DOpt &&
              <div className="twod-map-option-right" > 
                <ul className="">
                    <li>   
                      <a onClick={this.showPreview}>
                          <span className="icon icon-preview"> </span>
                          <span className="text">Preview</span>
                      </a>
                    </li>
                    <li>
                      <a onClick={this.showFloorplanner}>
                        <span className="icon icon-regenerate mr-1"> </span>
                        <span className="text">New</span>
                      </a>
                    </li>
                </ul>
              </div>
            }
          </div>
           :null
        } */}
        {/* <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id={`tooltip-twodmap`}>
              Shows doors and windows sizes, spacing, building dimensions, and lean tos on a 2D floor plan.
            </Tooltip>
          }
        >
          <button id="twoDmap" className="btn btn-white-shadow twod-map-btn d-none" onClick={this.downloadOnClick}><span className="icon icon-tools-alt"></span>
            <span className="text ml-1">2D Drawing</span>
          </button>
        </OverlayTrigger> */}
        <TwoDModalBody pdfGenerate={this.autoClick} />
        <div id="floorplanner" className="map-object" style={{ position: "fixed", justifyContent: "center", display: "none", height: this.state.windowHeight, width: this.state.windowWidth, left: 0, top: 0 }}>
          <TwoDFloorplanner building_data={this.props.customData} purpose="save" />
        </div>
        {/*-------- The commented is for showing manually gentated 2D ----------------------- */}
        {/* {Show2DModal == true ?
          <>
            <Modal
              centered
              backdrop="static"
              keyboard={false}
              show={this.state.isOpenSVG}
              aria-labelledby="contained-modal-title-vcenter"
              dialogClassName="twod-map-modal react-modal"
              backdropClassName="ract-modal-pre-parent twod-map-pre-parent"
              onShow={() => this.onShowPreview()}
            >
              <button className="close" onClick={(e) => this.hidePreview()}><span className="icon-close"></span></button>
              <Modal.Body >
                <div id="svg" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }} className="map-inner" ref={(el) => (this.componentRef = el)}>
                  <div className="drawing-top-wrapper">
                    <div className="drawing-checkbox">
                      <div className="radio-group d-flex align-items-center">
                        <Checkbox onChange={(e) => this.addtoQuote(e.target.value, 'Preview' + this.state.previewIndex)}
                          checked={(const_var.twoDImageObj[this.state.previewIndex] != undefined && const_var.twoDImageObj[this.state.previewIndex].is_checked != undefined && const_var.twoDImageObj[this.state.previewIndex].is_checked == true) ? const_var.twoDImageObj[this.state.previewIndex].is_checked : false}
                          label={'Add to Quote/Order'} />
                      </div>
                    </div>
                    <div className="drawing-available"><p>{this.state.previewStatus} Drawing</p></div>
                    <div className="drawing-nextperv">
                      {(this.state.prevEnable == true) ?
                        <a className="prevcta" onClick={() => this.onPrevPreview()}>

                          <span className="icon-arrow-thin arrow-thin-left"></span>

                          <span className="text">Prev</span>


                        </a>
                        : null
                      }
                      {(this.state.nextEnable == true) ?
                        <a className="nextcta" onClick={() => this.onNextPreview()}>

                          <span className="icon-arrow-thin arrow-thin-right"></span>

                          <span className="text">Next</span>


                        </a>
                        : null
                      }


                    </div>
                  </div>
                  <div className="map-notation" style={{ display: "flex", justifyContent: "center" }}>
                    <TwoDMapNotation overlapIcon={this.props.overlapIcon} />
                  </div>
                  <div id="svg1" className="map-object" style={{ display: "flex", justifyContent: "center" }}>
                    <img src="logo512.png" id="previewImg" style={{ maxWidth: '96%', maxHeight: '96%', height: 'auto' }} />
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            <Modal
              centered
              backdrop="static"
              keyboard={false}
              show={this.state.isOpenFloorplanner}
              aria-labelledby="contained-modal-title-vcenter"
              dialogClassName="twod-map-modal react-modal p-0 m-0 pl-0 pr-0 ml-0 mr-0"
              backdropClassName="ract-modal-pre-parent pl-0 pr-0 ml-0 mr-0"
              className="pl-0 pr-0 ml-0 mr-0"
            >
              <Modal.Body className="p-0">
                <div id="svg1" className="map-object" style={{ display: "flex", justifyContent: "center", height: this.state.windowHeight, width: this.state.windowWidth }}>
                  <TwoDFloorplanner
                    building_data={this.props.customData}
                    purpose="view"
                    ref={c => {
                      this.viewFloorplanner = c;
                    }}
                    hideFloorplanner={this.hideFloorplanner}
                  />
                </div>
              </Modal.Body>
            </Modal></> :
          <Modal
            centered
            size="lg"
            backdrop="static"
            dialogClassName="react-modal twod-map-video-modal"
            backdropClassName="ract-modal-pre-parent"
            onHide={this.downloadOnClick}
            keyboard={false}
            show={this.state.isOpenSVG}
          >
            <button className="close" onClick={(e) => this.downloadOnClick()}><span className="icon-close"></span></button>
            <Modal.Body >
              <div className="twodmap-video-wrapper">
                <video autoplay="autoplay">
                  <source src={`${baseUrl}${TwodMapVideo}`} type="video/mp4" />
                </video>
              </div>
              <div className="video-caption-wrapper">
                <p>With this Premium Feature, you can <span>PRINT & DOWNLOAD</span> the 2D Drawing of the building to send to customers and manufacturers.</p>
                <p>Please contact administrator to subscribe this feature.</p>
              </div>
            </Modal.Body>
          </Modal>} */}
      </Fragment>
    );
  }
}
const mapDispatchToProps = {
  prepareTwoDMapData,
  downloadOnClick
};
const mapStateToProps = (state) => {
  return { ...state.reducer, ...state.twoDMapReducer };
};
export default connect(mapStateToProps, mapDispatchToProps)(TwoDMapModal);
